
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/certificate-manager",
      function () {
        return require("private-next-pages/pam/certificate-manager.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/certificate-manager"])
      });
    }
  